import React, { FormEvent, useState } from 'react';
import Header from '../Header';
import { Input } from '../../Input/Input';
import Radio from '../../Radio';
import RadioGroup from '../../RadioGroup';
import Checkbox from '../../Checkbox';
import { Dropdown } from '../../Dropdown/Dropdown';
import { Button } from '../../Button/Button';
import { useLoginContext } from '../Login';
import { dateList, monthList, getYearList } from '../../../utils/dates';
import { ErrorMessageTypes } from '../types';
import styles from './Registration.module.scss';
import classNames from 'classnames';

const Registration = () => {
  const { errorMessage, backToPrev, handleRegister } = useLoginContext();
  const [agreedTerm, setAgreedTerm] = useState<boolean>(false);
  const [password, setPassword] = useState<string>('');
  const [rePassword, setRePassword] = useState<string>('');
  const [validationError, setValidationError] = useState<ErrorMessageTypes>();

  const [dateBirthdate, setDateBirthdate] = useState({
    hasChange: false,
    label: null,
    value: null,
  });

  const [monthBirthdate, setMonthBirthdate] = useState({
    hasChange: false,
    label: null,
    value: null,
  });

  const [yearBirthdate, setYearBirthdate] = useState({
    hasChange: false,
    label: null,
    value: null,
  });
  
  const handleSubmit = (e) => {
    e.preventDefault();

    const { fullname, gender, phone } = e.target;

    const payload = {
      fullname: fullname.value,
      gender: gender.value,
      date: dateBirthdate?.value ?? '01',
      month: monthBirthdate.value ?? '01',
      year: yearBirthdate.value ?? '2007',
      phone: phone.value,
      password: password,
      repassword: rePassword
    }
    
    handleRegister(payload);
  }

  const handlePasswordChange = (passwordValue: string) => {
    setValidationError({ password: null });
    setPassword(passwordValue);

    const passwordRegx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,}$/;
    const passwordTest = passwordRegx.test(passwordValue);
    
    if (!passwordTest) {
      setValidationError({ password: 'Kata sandi minimal 8 karakter, menggunakan huruf besar, huruf kecil, angka, dan minimal 1 karakter simbol.' })
    }
  }

  const handleRepasswordChange = (repasswordValue: string) => {
    setValidationError({ repassword: null });
    setRePassword(repasswordValue);

    if (!repasswordValue || repasswordValue.length <= 0 || repasswordValue === password) {
      return;
    }

    setValidationError({ repassword: 'Konfirmasi Password tidak sama.' })
  }

  return (
    <div className={styles.registration__background}>
      <div className={styles.registration__box}>
        <Header isModal={true} showBackBtn={true} onBackBtnClick={() => backToPrev('login')} />
        <form onSubmit={handleSubmit}>
          <div className={styles.field}>
            <div className={styles.field__text}>
              <Input
                name='fullname'
                type='text'
                inputMode='text'
                placeholder='Nama Lengkap'
                onChange={() => { }}
                size='md'
                error={errorMessage && errorMessage.fullname}
              />
            </div>
          </div>

          <div className={styles.field}>
            <label htmlFor='gender' className={styles.gender__label}>Jenis Kelamin</label>
            <RadioGroup id='radio__group__wrap' groupAlignment='horizontal'>
              <Radio
                id='gender'
                name='gender'
                labelName='Pria'
                value='MALE'
                handleOnChange={() => { }}
              />
              <Radio
                id='gender'
                name='gender'
                labelName='Wanita'
                value='FEMALE'
                handleOnChange={() => { }}
              />
            </RadioGroup>
            {errorMessage && errorMessage.gender && <span className={styles['error-msg']}>{errorMessage.gender}</span>}
          </div>

          <div className={styles.field}>
            <label htmlFor='birthdate' className={styles.birthdate__label}>Tanggal Lahir</label>
            <div className={styles.field__birthdate}>
              <Dropdown
                id='date'
                name='date'
                options={dateList}
                value={{
                  label: dateBirthdate.label ?? dateList[0].label,
                  value: dateBirthdate.value ?? dateList[0].value,
                }}
                callback={(d) => {
                  setDateBirthdate({
                    hasChange: true,
                    value: d.value,
                    label: d.label,
                  });
                }}
              />
              <Dropdown
                id='month'
                name='month'
                options={monthList}
                value={{
                  label: monthBirthdate.label ?? monthList[0].label,
                  value: monthBirthdate.value ?? monthList[0].value,
                }}
                callback={(m) => {
                  setMonthBirthdate({
                    hasChange: true,
                    value: m.value,
                    label: m.label,
                  });                  
                }}
              />
              <Dropdown
                id='year'
                name='year'
                options={getYearList()}
                value={{
                  label: yearBirthdate.label ?? getYearList()[0].label,
                  value: yearBirthdate.value ?? getYearList()[0].value,
                }}
                callback={(y) => {
                  setYearBirthdate({
                    hasChange: true,
                    value: y.value,
                    label: y.label,
                  });                  
                }}
              />
            </div>
          </div>

          <div className={styles.field}>
            <div className={styles.field__text}>
              <Input
                name='phone'
                type='tel'
                inputMode='tel'
                placeholder='Nomor Telepon'
                onChange={() => { }}
                size='md'
                error={errorMessage && errorMessage.phoneNumber}
              />

            </div>
          </div>

          <div className={styles.field}>
            <div className={styles.field__text}>
              <Input
                name='password'
                type='password'
                inputMode='text'
                placeholder='Password'
                value={password}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => handlePasswordChange(e.target.value)}
                size='md'
                error={(validationError && validationError.password) || (errorMessage && errorMessage.password)}
              />
            </div>
          </div>

          <div className={styles.field}>
            <div className={styles.field__text}>
              <Input
                name='repassword'
                type='password'
                inputMode='text'
                placeholder='Konfirmasi Password'
                value={rePassword}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleRepasswordChange(e.target.value)}
                size='md'
                error={(validationError && validationError.repassword) || (errorMessage && errorMessage.repassword)}
              />
            </div>
          </div>

          <div className={styles.field}>
            <div className={styles.field__term}>
              <Checkbox
                id='tc_checkbox'
                labelName=''
                labelHidden={false}
                onChange={() => setAgreedTerm(!agreedTerm)}
              />
              <span>Saya setuju dengan <a href='/ketentuan/'>Kebijakan Pengunaan</a>  Lifepal </span>
            </div>
          </div>

          <Button
            variant='primary'
            id='regis-btn'
            type='submit'
            isBlock={true}
            disabled={!agreedTerm}
            className={classNames(styles['action-button'], styles['bottom-16p'])}
            onClick={() => { }}
          >
            Daftar
          </Button>
        </form>
      </div>
    </div>
  )
}

export default Registration;